// extracted by mini-css-extract-plugin
export default {"buttonChangeProfile":"styles_buttonChangeProfile__uOue5"};